// Dot pagination for a Dawn slider: one dot per visible slide, the current one larger.
if (!customElements.get('slider-dots')) {
  customElements.define(
    'slider-dots',
    class SliderDots extends HTMLElement {
      connectedCallback() {
        this.slider = this.closest('slider-component')?.querySelector('[id^="Slider-"]');
        if (!this.slider) return;

        this.update = this.update.bind(this);
        this.slider.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.render());
        this.resizeObserver.observe(this.slider);
        this.render();
      }

      disconnectedCallback() {
        this.slider?.removeEventListener('scroll', this.update);
        this.resizeObserver?.disconnect();
      }

      render() {
        this.slides = Array.from(this.slider.querySelectorAll('[id^="Slide-"]')).filter(
          (slide) => slide.clientWidth > 0
        );

        if (this.slides.length < 2) {
          this.replaceChildren();
          return;
        }

        if (this.children.length !== this.slides.length) {
          this.replaceChildren(
            ...this.slides.map((slide, index) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'slider-dots__dot';
              dot.setAttribute('aria-label', `${this.dataset.label} ${index + 1}`);
              dot.addEventListener('click', () => {
                this.slider.scrollTo({ left: this.slides[index].offsetLeft - this.slides[0].offsetLeft });
              });
              return dot;
            })
          );
        }

        this.update();
      }

      update() {
        if (!this.slides || this.slides.length < 2) return;

        const step = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        const current = Math.min(Math.round(this.slider.scrollLeft / step), this.slides.length - 1);

        Array.from(this.children).forEach((dot, index) => {
          const isCurrent = index === current;
          dot.classList.toggle('is-selected', isCurrent);
          if (isCurrent) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
